export const UPDATE_USERS_SORT = 'UPDATE_USERS_SORT';
export const UPDATE_SEARCH_STRING = 'UPDATE_SEARCH_STRING';
export const UPDATE_LATEST_ADDED_USERS = 'UPDATE_LATEST_ADDED_USERS';

// Add
export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';

// Delete
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

// Update
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

// Search
export const FETCH_SCOPED_USERS_REQUEST = 'FETCH_SCOPED_USERS_REQUEST';
export const FETCH_SCOPED_USERS_SUCCESS = 'FETCH_SCOPED_USERS_SUCCESS';
export const FETCH_SCOPED_USERS_FAILURE = 'FETCH_SCOPED_USERS_FAILURE';

// Search Next
export const FETCH_SCOPED_USERS_NEXT_REQUEST = 'FETCH_SCOPED_USERS_NEXT_REQUEST';
export const FETCH_SCOPED_USERS_NEXT_SUCCESS = 'FETCH_SCOPED_USERS_NEXT_SUCCESS';
export const FETCH_SCOPED_USERS_NEXT_FAILURE = 'FETCH_SCOPED_USERS_NEXT_FAILURE';

// Permissions
export const GET_PERMISSIONS_REQUEST = 'GET_PERMISSIONS_REQUEST';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
export const GET_PERMISSIONS_FAILURE = 'GET_PERMISSIONS_FAILURE';
